export default __webpack_public_path__ + "2464a9b03b45e3584282d3ca625722b2.coffee";